import createImmutableSelector from 'lib/immutable/selector'
import { IContact } from '../models'

// TODO: import Store type and add reducer type in Store interface
const getContact = (state: any): IContact => state.get('contactReducer')

export const contactSelector = createImmutableSelector(getContact, (contact) => contact)
